(function (angular) {
    angular.module('bizPartEngage').controller('modules.goals.tasks', indexController);
    angular.module('bizPartEngage').controller('modules.goals.onetask', oneTaskController);

    indexController.$inject = ["modules.goals.service", "$stateParams"];
    oneTaskController.$inject = ["modules.goals.service", "$stateParams"];

    function indexController(engagementGoalsService) {
        var vm = this;     

        vm.SelectedPeriod = engagementGoalsService.GetSelectedPeriod();

        vm.$onInit = function () {
            
        }
    }

    function oneTaskController(engagementGoalsService, $stateParams) {
        var vm = this;

        vm.GetOneTask = GetOneTask;

        vm.taskId = ~~$stateParams.id;
        vm.goalId = ~~$stateParams.goalId;
        vm.activityId = ~~$stateParams.activityId;

        vm.Back = Back;

        function Back() {
            window.history.back();
        }

        function GetOneTask(id) {
            engagementGoalsService.GetOneTask(id).then(GetOneTaskCallback);

            function GetOneTaskCallback(response) {
                vm.task = BizPartCoreHelpers.getResponseValue(response);
            }
        }

        vm.$onInit = function () {
            if (vm.taskId > 0) {
                vm.GetOneTask(vm.taskId);
            } else {
                vm.task = {
                    Id: 'new',
                    EditDate: engagementGoalsService.GetSelectedPeriod().Date,
                    EditMode: true,
                    GoalId: vm.goalId,
                    ActivityId: vm.activityId
                };
            }
        }
    }

})(window.angular);
